import styled from '@emotion/styled';
import Image from '../components/Image';

export const PostItemImage = styled(Image)`
  width: 128px;
  height: 96px;
  object-fit: cover;
  border-radius: ${({ theme }) => theme.spacing(0.5)};
`;

export const LogoImage = styled(Image)`
  width: 96px;
  height: 96px;
  object-fit: contain;
  border-radius: ${({ theme }) => theme.spacing(0.5)};
`;
